import { RANGE_FILTER_SEPARATOR } from '@aibees/elephant/constants/filters';
import { useQueryStringState } from '@aibees/shared/hooks';
import { useMemo } from 'react';

export function usePresentChecked(field: string) {
  const { params } = useQueryStringState();
  return useMemo(
    () =>
      params[field]?.split(RANGE_FILTER_SEPARATOR)?.[1] === 'Present' || false,
    [params, field]
  );
}
